import React from 'react';
import PropTypes from 'prop-types';
import { get } from 'lodash';
import moment from 'moment';

import Count from '../../components/Count';
import ShowMore from '../../components/ShowMore';
import { addBulletIfSet } from '../../utils/shared';

import defaultImage from '../../assets/images/landscape-default.jpg';

import './styles/MovieInfo.css';

const MovieInfo = props => {
  const { movie, loading, count } = props;
  const addBullet = (content, key) => [
    <span key={key} className="inline-bullet">
      •
    </span>,
    ` ${content} `
  ];

  const formatDate = date => {
    if (!date) {
      return '';
    }

    return moment(date).format('MMMM DD, YYYY');
  };

  const showLoadingState = () => (
    <>
      <div className="loading-state-movie-info-root">
        <div className="loading-state-movie-thumbnail gradient-animation" />
        <div className="loading-state-movie-info__wrapper">
          <div className="loading-state-movie-title gradient-animation" />
          <div className="loading-state-movie-title gradient-animation" />
          <div className="loading-state-movie-title gradient-animation" />
        </div>
      </div>
    </>
  );
  const artworkPoster = get(movie, 'artwork_poster', false);
  const getMovieStatus = () => {
    if (movie.status === 'Announced') {
      return (
        <>
          Announced {addBulletIfSet(movie.releaseDate)}{' '}
          {movie.releaseDate ? 'Premieres on  ' : ' '}
          {formatDate(movie.releaseDate)}
        </>
      );
    }
    if (movie.status === 'Released') {
      return (
        <>
          Released {addBulletIfSet(movie.releaseDate)}{' '}
          {movie.releaseDate ? 'Premiered on  ' : ' '}
          {formatDate(movie.releaseDate)}
        </>
      );
    }
    return `Movie Status `;
  };
  return loading ? (
    showLoadingState()
  ) : (
    <div className="movie-info-root">
      <img
        className="movie-thumbnail"
        alt={`${movie.name} thumbnail`}
        src={
          artworkPoster && artworkPoster.length ? artworkPoster : defaultImage
        }
      />
      <div className="movie-info__wrapper">
        <h1 className="movie-title">{movie.name}</h1>
        <p className="movie-info">
          {getMovieStatus()}
          {movie.genres
            ? addBullet(
                `${movie.genres
                  .split('|')
                  .filter(f => f && f.length > 0)
                  .map(g => g.trim())
                  .join(', ')}`,
                ''
              )
            : null}
          {movie.studio ? addBullet(`${movie.studio}`, 'studio') : null}
          {movie.runtime ? addBullet(`${movie.runtime}`, 'director') : null}
        </p>
        <ShowMore text={movie.overview} maxLength={190} />
        {count ? (
          <Count count={count} unitSingular="Follower" unitPlural="Followers" />
        ) : null}
      </div>
    </div>
  );
};

MovieInfo.propTypes = {
  movie: PropTypes.shape({
    name: PropTypes.string,
    releaseDate: PropTypes.string,
    genres: PropTypes.string,
    runtime: PropTypes.string,
    overview: PropTypes.string,
    studio: PropTypes.string,
    status: PropTypes.string
  }).isRequired,
  count: PropTypes.number,
  loading: PropTypes.bool
};

MovieInfo.defaultProps = {
  count: 0,
  loading: false
};

export default MovieInfo;
